import { createFileRoute } from '@tanstack/react-router';

import { NotificationsListPage } from '@/features/notifications/NotificationsListPage';

export const Route = createFileRoute('/admin/_app/notifications/')({
  component: NotificationsListPage,
});
